import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { guiaColumnasFijas } from "../../../../guias/index";
import { MotivoGuiaItem } from "./model";

type Entity = MotivoGuiaItem;
export interface Deps {
    onMotivoChange : (x: Entity, motivo: string) => void;
}

export function columnas(deps: Deps) {
    const ret : kea.Grid2Column<Entity>[] = [
        {
            title: "Motivo de cancelación por guia", 
            key: "motivo",
            cell: x => ({
                data: x.MotivoCancelacion,
                view: () => <kea.Text 
                value={x.MotivoCancelacion} 
                onChange={val => deps.onMotivoChange(x, val)} 
                placeholder="Opcional" />
            }),
        },
        ...(guiaColumnasFijas as kea.Grid2Column<Entity>[])
    ];

    return kea.applyRowStyleToColumns(ret, 
        x => x.MotivoCancelacion != undefined ? {background: "yellow"} : {}
    );
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/cancelacion/list/motivoguias/columns.tsx